export default __webpack_public_path__ + "static/media/twitterDeskMobile.1b1cd431.svg";